var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.188,
    height: 17.629,
    viewBox: "0 0 53.188 17.629",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_209",
    "data-name": "Groupe 209",
    transform: "translate(-1069.406 -508.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-hand-rock",
    "data-name": "Icon awesome-hand-rock",
    d: "M17.248,4.031a1.781,1.781,0,0,0-1.811,1.781h-.3V4.655a1.8,1.8,0,0,0-1.752-1.811,1.781,1.781,0,0,0-1.811,1.781V5.812h-.3V4.061A1.8,1.8,0,0,0,9.53,2.25,1.781,1.781,0,0,0,7.719,4.031V5.812h-.3V4.655A1.8,1.8,0,0,0,5.67,2.844,1.781,1.781,0,0,0,3.859,4.625V9.672l-.3-.263V7.623A1.8,1.8,0,0,0,1.811,5.812,1.781,1.781,0,0,0,0,7.594v2.464a3.571,3.571,0,0,0,1.195,2.664L5.34,16.407a1.789,1.789,0,0,1,.6,1.332v.249a.888.888,0,0,0,.891.891h8.906a.888.888,0,0,0,.891-.891V17.88A3.615,3.615,0,0,1,16.9,16.5l1.818-4.316A3.547,3.547,0,0,0,19,10.8V5.842a1.8,1.8,0,0,0-1.752-1.811Z",
    transform: "translate(1086.5 506.75)",
    fill: "none",
    stroke: "#777",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrow-right",
    "data-name": "Icon awesome-arrow-right",
    d: "M4.44,3.329l.517-.517a.557.557,0,0,1,.79,0L10.279,7.34a.557.557,0,0,1,0,.79L5.748,12.662a.557.557,0,0,1-.79,0l-.517-.517a.56.56,0,0,1,.009-.8L7.258,8.669H.559A.558.558,0,0,1,0,8.11V7.364A.558.558,0,0,1,.559,6.8h6.7L4.45,4.129A.556.556,0,0,1,4.44,3.329Z",
    transform: "translate(1112.15 509.578)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrow-right-2",
    "data-name": "Icon awesome-arrow-right",
    d: "M4.44,3.329l.517-.517a.557.557,0,0,1,.79,0L10.279,7.34a.557.557,0,0,1,0,.79L5.748,12.662a.557.557,0,0,1-.79,0l-.517-.517a.56.56,0,0,1,.009-.8L7.258,8.669H.559A.558.558,0,0,1,0,8.11V7.364A.558.558,0,0,1,.559,6.8h6.7L4.45,4.129A.556.556,0,0,1,4.44,3.329Z",
    transform: "translate(1079.85 525.051) rotate(180)",
    fill: "#777"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPan);
export default __webpack_public_path__ + "static/media/icon-pan.0d7259b67778204a06c3979adf9a94e4.svg";
export { ForwardRef as ReactComponent };